export const defaultFormOutlineStyles = {
    width:"fit-content",
    border:"1px solid",
    borderColor:"#CBD5E0",
    borderRadius:"0.6em", 
    padding:"1em"
};
